import type { Dispatch } from "@reduxjs/toolkit";
import { App, Spin } from "antd";
import { useEffect } from "react";
import { connect } from "react-redux";
import { actions } from "../features/app-feedback/appFeedbackSlice";
import type { RootState } from "./store";

type AntAppFeedbackProps = {
	dispatch: Dispatch;
};

function AntAppFeedback(props: AntAppFeedbackProps) {
	const { dispatch } = props;

	const { message, notification, modal } = App.useApp();
	useEffect(() => {
		if (message && notification && modal) {
			dispatch(
				actions.setAppFeedbackControls({ modal, message, notification }),
			);
		}
	}, [dispatch, message, notification, modal]);

	return <Spin fullscreen spinning={false} description="" />;
}

const AntAppFeedbackConnected = connect((_state: RootState) => ({}))(
	AntAppFeedback,
);

export default AntAppFeedbackConnected;
